export function MenuCloseIcon({ classname }: { classname?: string }) {
  return (
    <svg
      width="32"
      height="25"
      viewBox="0 0 32 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
    >
      <rect
        x="4"
        y="22.7529"
        width="32"
        height="2"
        transform="rotate(-45 4 22.7529)"
        fill="currentColor"
      />
      <rect
        x="5"
        y="0.125488"
        width="32"
        height="2"
        transform="rotate(45 5 0.125488)"
        fill="currentColor"
      />
    </svg>
  );
}
